import { axios } from "../connection/ConnectionHandler";
import { API } from "../constants/api";
import { createCrudActions } from '../utils/crudGenerator';

const formatProjects = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchProjects,
    create: createProject,
    update: updateProject,
    delete: deleteProjects
} = createCrudActions('PROJECT', "Proyecto", formatProjects);

/** Proyectos del ERP (TipData) — solo consulta, no actualiza Redux */
export const fetchProjectsFromErp = () => async () => {
    const response = await axios.get(API.projectsTip.projectsTip);
    return response.data;
};